// src/utils/rulePlans/genericRulePlans.js
// Generic remediation plan helpers used when a rule family does not yet have a specialized plan.

export function inferProviderFromRule(ruleId = "") {
  const rule = String(ruleId || "").toUpperCase();

  if (
    rule.includes("IAM") ||
    rule.includes("S3") ||
    rule.includes("CLOUDTRAIL") ||
    rule.includes("TRAIL") ||
    rule.includes("CONFIG") ||
    rule.includes("DRIFT")
  ) {
    return "AWS";
  }

  return "Source system";
}

export function buildGenericFixPlanSteps(item = {}, relatedSops = []) {
  const rule = String(item?.rule_id || item?.ruleId || "").toUpperCase();
  const provider = inferProviderFromRule(rule);
  const sopStep = relatedSops.length
    ? "Review the linked governing SOP before approving exceptions or closing the finding."
    : "Link or create a governing SOP so remediation follows a controlled procedure.";

  return [
    `Open ${provider}.`,
    "Find the resource, identity, policy, or bucket referenced by the finding.",
    "Open the configuration area tied to the rule shown in this fix plan.",
    "Compare the current setting to the control requirement and evidence details.",
    sopStep,
    "Apply the remediation or document an approved exception.",
    "Return to OASYS and run Full Cloud Assessment.",
    "Confirm the score, failing count, and stale evidence count update after the assessment completes.",
  ];
}

export function buildGenericValidationText() {
  return "OASYS will validate the fix after source data is synced and posture is recalculated.";
}
